var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Autocomplete, CircularProgress, Divider, FormControl, Grid, InputAdornment, OutlinedInput, TextField, Typography, } from '@mui/material';
import { DesktopDateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useAsyncAction } from 'app/services';
import { inspectionFilterLoad } from 'app/store/checklist';
import moment from 'moment';
import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
const FormDivider = (props) => {
    const { label } = props;
    return (React.createElement(Divider, { textAlign: 'center', sx: (theme) => ({
            width: '100%',
            alignSelf: 'center',
            justifyContent: 'center',
            marginTop: theme.spacing(1.25),
            marginBottom: theme.spacing(1.25),
        }) },
        React.createElement(Typography, { variant: 'body2' }, label)));
};
const ChecklistInspectionFilterForm = forwardRef((props, ref) => {
    const { defaultValues, onSubmit } = props;
    const { inspectionFiltersData } = useSelector((state) => state.checklist);
    const { control, watch, register, setValue, handleSubmit } = useForm({
        defaultValues,
    });
    const { asyncAction: fetchFilterData, isLoading: isFetchFilterLoading } = useAsyncAction(inspectionFilterLoad);
    const fromWatch = watch('from');
    const handleChangeFromDatetime = (newValue) => {
        setValue('from', moment(newValue).format('YYYY-MM-DD HH:mm:ss'));
    };
    const handleChangeToDatetime = (newValue) => {
        setValue('to', moment(newValue).format('YYYY-MM-DD HH:mm:ss'));
    };
    useImperativeHandle(ref, () => ({
        handleFormSubmit: () => {
            handleSubmit((data) => onSubmit(data))();
        },
    }));
    useEffect(() => {
        fetchFilterData();
    }, []);
    return (React.createElement("form", null,
        React.createElement(FormDivider, { label: '\u0412\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0439 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B' }),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(LocalizationProvider, { dateAdapter: AdapterMoment, adapterLocale: moment.locale('ru') },
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(FormControl, { margin: 'normal', variant: 'outlined', fullWidth: true },
                        React.createElement(Controller, { name: 'from', control: control, render: ({ field }) => (React.createElement(DesktopDateTimePicker, { label: '\u041D\u0430\u0447\u0430\u043B\u043E', views: ['day', 'hours'], minDate: moment().subtract(90, 'days'), maxDate: moment(), inputFormat: 'DD.MM.YYYY HH:mm:ss', value: field.value, onChange: handleChangeFromDatetime, renderInput: (_a) => {
                                    var { error } = _a, params = __rest(_a, ["error"]);
                                    return (React.createElement(TextField, Object.assign({}, params, { sx: {
                                            svg: {
                                                fontSize: '20px',
                                            },
                                        } }, register(field.name))));
                                } })) }))),
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(FormControl, { margin: 'normal', variant: 'outlined', fullWidth: true },
                        React.createElement(Controller, { name: 'to', control: control, render: ({ field }) => (React.createElement(DesktopDateTimePicker, { label: '\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0435', views: ['day', 'hours'], minDate: fromWatch, maxDate: moment(), inputFormat: 'DD.MM.YYYY HH:mm:ss', value: field.value, onChange: handleChangeToDatetime, renderInput: (_a) => {
                                    var { error } = _a, params = __rest(_a, ["error"]);
                                    return (React.createElement(TextField, Object.assign({}, params, { sx: {
                                            svg: {
                                                fontSize: '20px',
                                            },
                                        } }, register(field.name))));
                                } })) }))))),
        React.createElement(FormDivider, { label: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u0430' }),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormControl, { margin: 'normal', variant: 'outlined', fullWidth: true },
                    isFetchFilterLoading && (React.createElement(OutlinedInput, { disabled: true, placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u0430', endAdornment: React.createElement(InputAdornment, { position: 'end' },
                            React.createElement(CircularProgress, { size: 16 })) })),
                    !isFetchFilterLoading && (React.createElement(Autocomplete, { multiple: true, filterSelectedOptions: true, clearText: '', closeText: '', noOptionsText: '\u041F\u043E \u0434\u0430\u043D\u043D\u043E\u043C\u0443 \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E', options: inspectionFiltersData.template, getOptionLabel: (option) => option.name, onChange: (event, options) => setValue('template_id', options.map((option) => option.id)), key: inspectionFiltersData.template.filter((item) => defaultValues.template_id.includes(item.id)), defaultValue: inspectionFiltersData.template.filter((item) => defaultValues.template_id.includes(item.id)), ChipProps: {
                            sx: {
                                margin: '0!important',
                                marginRight: '4px!important',
                                height: '24px',
                                '.MuiChip-label': {
                                    padding: '0 8px',
                                },
                                '.MuiChip-deleteIcon': {
                                    fontSize: '16px',
                                },
                            },
                        }, componentsProps: {
                            paper: {
                                sx: {
                                    maxHeight: 200,
                                    overflow: 'auto',
                                    marginTop: '1px',
                                    '&:before': {
                                        display: 'none',
                                    },
                                    '.MuiAutocomplete-listbox': {
                                        overflow: 'hidden',
                                    },
                                    '.MuiAutocomplete-option': {
                                        paddingTop: '6px',
                                        paddingBottom: '6px',
                                        paddingLeft: '12px',
                                        paddingRight: '12px',
                                        fontSize: '12px',
                                    },
                                    '.MuiAutocomplete-noOptions': {
                                        fontSize: '12px',
                                    },
                                },
                            },
                        }, renderInput: (props) => (React.createElement(TextField, Object.assign({}, props, { placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u0430', sx: {
                                '.MuiOutlinedInput-root': {
                                    paddingTop: '14px',
                                    paddingBottom: '14px',
                                    paddingLeft: '14px',
                                },
                                '.MuiOutlinedInput-input': {
                                    padding: '0!important',
                                },
                            } }))) }))))),
        React.createElement(FormDivider, { label: '\u0421\u0442\u0430\u0442\u0443\u0441' }),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormControl, { margin: 'normal', variant: 'outlined', fullWidth: true },
                    React.createElement(Autocomplete, { multiple: true, clearText: '', closeText: '', noOptionsText: '\u041F\u043E \u0434\u0430\u043D\u043D\u043E\u043C\u0443 \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E', options: config.inspectionStatuses, getOptionLabel: (option) => option.label, onChange: (event, options) => setValue('status', options.map((option) => option.value)), key: config.inspectionStatuses.filter((item) => defaultValues.status.includes(item.value)), defaultValue: config.inspectionStatuses.filter((item) => defaultValues.status.includes(item.value)), ChipProps: {
                            sx: {
                                margin: '0!important',
                                marginRight: '4px!important',
                                height: '24px',
                                '.MuiChip-label': {
                                    padding: '0 8px',
                                },
                                '.MuiChip-deleteIcon': {
                                    fontSize: '16px',
                                },
                            },
                        }, componentsProps: {
                            paper: {
                                sx: {
                                    maxHeight: 200,
                                    overflow: 'auto',
                                    marginTop: '1px',
                                    '&:before': {
                                        display: 'none',
                                    },
                                    '.MuiAutocomplete-listbox': {
                                        overflow: 'hidden',
                                    },
                                    '.MuiAutocomplete-option': {
                                        paddingTop: '6px',
                                        paddingBottom: '6px',
                                        paddingLeft: '12px',
                                        paddingRight: '12px',
                                        fontSize: '12px',
                                    },
                                    '.MuiAutocomplete-noOptions': {
                                        fontSize: '12px',
                                    },
                                },
                            },
                        }, renderInput: (props) => (React.createElement(TextField, Object.assign({}, props, { placeholder: '\u0421\u0442\u0430\u0442\u0443\u0441', sx: {
                                '.MuiOutlinedInput-root': {
                                    paddingTop: '14px',
                                    paddingBottom: '14px',
                                    paddingLeft: '14px',
                                },
                                '.MuiOutlinedInput-input': {
                                    padding: '0!important',
                                },
                            } }))) })))),
        React.createElement(FormDivider, { label: '\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A' }),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormControl, { margin: 'normal', variant: 'outlined', fullWidth: true },
                    isFetchFilterLoading && (React.createElement(OutlinedInput, { disabled: true, placeholder: '\u0424\u0418\u041E \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430', endAdornment: React.createElement(InputAdornment, { position: 'end' },
                            React.createElement(CircularProgress, { size: 16 })) })),
                    !isFetchFilterLoading && (React.createElement(Autocomplete, { multiple: true, filterSelectedOptions: true, clearText: '', closeText: '', noOptionsText: '\u041F\u043E \u0434\u0430\u043D\u043D\u043E\u043C\u0443 \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E', options: inspectionFiltersData.employee, getOptionLabel: (option) => option.name, onChange: (event, options) => setValue('employee_id', options.map((option) => option.id)), key: inspectionFiltersData.employee.filter((item) => defaultValues.employee_id.includes(item.id)), defaultValue: inspectionFiltersData.employee.filter((item) => defaultValues.employee_id.includes(item.id)), ChipProps: {
                            sx: {
                                margin: '0!important',
                                marginRight: '4px!important',
                                height: '24px',
                                '.MuiChip-label': {
                                    padding: '0 8px',
                                },
                                '.MuiChip-deleteIcon': {
                                    fontSize: '16px',
                                },
                            },
                        }, componentsProps: {
                            paper: {
                                sx: {
                                    maxHeight: 200,
                                    overflow: 'auto',
                                    marginTop: '1px',
                                    '&:before': {
                                        display: 'none',
                                    },
                                    '.MuiAutocomplete-listbox': {
                                        overflow: 'hidden',
                                    },
                                    '.MuiAutocomplete-option': {
                                        paddingTop: '6px',
                                        paddingBottom: '6px',
                                        paddingLeft: '12px',
                                        paddingRight: '12px',
                                        fontSize: '12px',
                                    },
                                    '.MuiAutocomplete-noOptions': {
                                        fontSize: '12px',
                                    },
                                },
                            },
                        }, renderInput: (props) => (React.createElement(TextField, Object.assign({}, props, { placeholder: '\u0424\u0418\u041E \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430', sx: {
                                '.MuiOutlinedInput-root': {
                                    paddingTop: '14px',
                                    paddingBottom: '14px',
                                    paddingLeft: '14px',
                                },
                                '.MuiOutlinedInput-input': {
                                    padding: '0!important',
                                },
                            } }))) }))))),
        React.createElement(FormDivider, { label: '\u0422\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E' }),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormControl, { margin: 'normal', variant: 'outlined', fullWidth: true },
                    isFetchFilterLoading && (React.createElement(OutlinedInput, { disabled: true, placeholder: '\u0413\u043E\u0441\u043D\u043E\u043C\u0435\u0440', endAdornment: React.createElement(InputAdornment, { position: 'end' },
                            React.createElement(CircularProgress, { size: 16 })) })),
                    !isFetchFilterLoading && (React.createElement(Autocomplete, { multiple: true, filterSelectedOptions: true, clearText: '', closeText: '', noOptionsText: '\u041F\u043E \u0434\u0430\u043D\u043D\u043E\u043C\u0443 \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E', options: inspectionFiltersData.transport, getOptionLabel: (option) => option.number, onChange: (event, options) => setValue('transport_id', options.map((option) => option.id)), key: inspectionFiltersData.transport.filter((item) => defaultValues.transport_id.includes(item.id)), defaultValue: inspectionFiltersData.transport.filter((item) => defaultValues.transport_id.includes(item.id)), ChipProps: {
                            sx: {
                                margin: '0!important',
                                marginRight: '4px!important',
                                height: '24px',
                                '.MuiChip-label': {
                                    padding: '0 8px',
                                },
                                '.MuiChip-deleteIcon': {
                                    fontSize: '16px',
                                },
                            },
                        }, componentsProps: {
                            paper: {
                                sx: {
                                    maxHeight: 200,
                                    overflow: 'auto',
                                    marginTop: '1px',
                                    '&:before': {
                                        display: 'none',
                                    },
                                    '.MuiAutocomplete-listbox': {
                                        overflow: 'hidden',
                                    },
                                    '.MuiAutocomplete-option': {
                                        paddingTop: '6px',
                                        paddingBottom: '6px',
                                        paddingLeft: '12px',
                                        paddingRight: '12px',
                                        fontSize: '12px',
                                    },
                                    '.MuiAutocomplete-noOptions': {
                                        fontSize: '12px',
                                    },
                                },
                            },
                        }, renderInput: (props) => (React.createElement(TextField, Object.assign({}, props, { placeholder: '\u0413\u043E\u0441\u043D\u043E\u043C\u0435\u0440', sx: {
                                '.MuiOutlinedInput-root': {
                                    paddingTop: '14px',
                                    paddingBottom: '14px',
                                    paddingLeft: '14px',
                                },
                                '.MuiOutlinedInput-input': {
                                    padding: '0!important',
                                },
                            } }))) })))))));
});
export default ChecklistInspectionFilterForm;
